'use strict';

exports.__esModule = true;
exports.default = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _Grid = require('react-bootstrap/lib/Grid');

var _Grid2 = _interopRequireDefault(_Grid);

var _Col = require('react-bootstrap/lib/Col');

var _Col2 = _interopRequireDefault(_Col);

var _Row = require('react-bootstrap/lib/Row');

var _Row2 = _interopRequireDefault(_Row);

var _mozart_ui = require('@pgforsta/mozart_ui');

var _components = require('components');

var _utilElement = require('utils/util-element.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Languages = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    survey: state.survey.data,
    client: state.client.data,
    selectedLanguage: state.survey.selectedLanguage
  };
}, null), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Languages, _Component);

  function Languages(props) {
    (0, _classCallCheck3.default)(this, Languages);

    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));

    _this.styles = require('./Languages.scss');
    _this.state = {
      Ishovering: false,
      cardId: '',
      height: window.innerHeight || document.documentElement.clientHeight,
      width: window.innerWidth || document.documentElement.clientWidth,
      device_type: (window.innerWidth || document.documentElement.clientWidth) <= 768 ? 'mobile' : 'desktop',
      selected_language: _this.props.currentLanguage,
      search_text: false,
      show_search: _this.props.showSearch ? _this.props.showSearch : false
    };
    (0, _utilElement.fireGTMEvent)(_utilElement.EVENT_PAGE_LOAD, _utilElement.EVENT_PAGE_LOAD, 'Loading languages listing page.');
    return _this;
  }

  Languages.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var survey = this.props.survey;

    var languages = survey && survey.data ? survey.data.languages : [];
    var defaultLanguage = survey && survey.data ? survey.data.defaultLanguage : null;
    (0, _keys2.default)(languages).map(function (key) {
      if (key === defaultLanguage) {
        _this2.setLanguage(defaultLanguage);
      }
    });
  };

  Languages.prototype.setLanguage = function setLanguage(language) {
    this.setState({ selected_language: language });

    this.props.onSelectLanguage(language);
  };

  Languages.prototype.getSingleLanguage = function getSingleLanguage(language, languageName) {
    var survey = this.props.survey;

    var style = {
      width: this.state.device_type === 'mobile' ? '50px' : '100px',
      margin: 'auto',
      height: this.state.device_type === 'mobile' ? '50px' : '100px',
      fontSize: this.state.device_type === 'mobile' ? '20px' : '35px',
      color: this.props.theme && this.props.theme.customTextColor ? this.props.theme.customTextColor : '#fff',
      backgroundColor: this.props.theme && this.props.theme.colorCode ? this.props.theme.colorCode : '#00253b'
    };
    var languageAbbrev = (0, _utilElement.getLanguageAbbreviation)();
    return _react2.default.createElement(
      _Col2.default,
      { xs: 12, sm: 12, md: 6, lg: 3 },
      _react2.default.createElement(
        'div',
        { 'data-qa-type': 'list_item', title: survey.data.languages[language], className: this.state.selected_language === language ? this.styles.language_container + ' ' + this.styles.language_selected : this.styles.language_container, onClick: this.setLanguage.bind(this, language),
          onMouseEnter: this.handleMouseEnter.bind(this, language),
          onMouseLeave: this.handleMouseLeave.bind(this),
          id: language
        },
        _react2.default.createElement(
          'div',
          { className: this.styles.language_flag },
          _react2.default.createElement(
            'div',
            { style: style, className: this.styles.laguage_circle },
            _react2.default.createElement(
              'span',
              null,
              languageAbbrev[language] ? languageAbbrev[language] : languageName.substring(0, 3).toUpperCase()
            )
          )
        ),
        survey && _react2.default.createElement(
          'div',
          { className: this.styles.language_survey_name },
          survey.data.name[language] ? survey.data.name[language] : ''
        ),
        _react2.default.createElement(
          'div',
          { className: this.styles.language_name },
          _react2.default.createElement(
            _Col2.default,
            { xs: 12, sm: 12, md: 12, lg: 12 },
            _react2.default.createElement(_mozart_ui.MozartButton, {
              data: survey.data.languages[language],
              style: {
                height: '30px',
                width: '90px',
                marginTop: '10px',
                fontSize: '14px',
                border: '1px solid ' + this.props.theme.colorCode
              }
            })
          )
        )
      )
    );
  };

  Languages.prototype.getLanguages = function getLanguages() {
    var _this3 = this;

    var survey = this.props.survey;

    var languages = survey && survey.data ? survey.data.languages : [];
    var languageElem = [];
    if (languages && (0, _keys2.default)(languages).length) {
      (0, _keys2.default)(languages).map(function (key) {
        if (_this3.state.search_text) {
          if (languages[key].toLowerCase().search(_this3.state.search_text.toLowerCase()) !== -1) {
            languageElem.push(_this3.getSingleLanguage(key, languages[key]));
          }
        } else {
          languageElem.push(_this3.getSingleLanguage(key, languages[key]));
        }
      });
    }
    if (!languageElem.length) {
      languageElem.push(_react2.default.createElement(
        'p',
        { className: this.styles.no_languages },
        'Sorry ! no items found.'
      ));
    }
    return languageElem;
  };

  Languages.prototype.handleSearch = function handleSearch(searchText) {
    if (searchText.length >= 1 || searchText === '') {
      this.setState({ search_text: searchText, show_search: false });
    }
  };

  Languages.prototype.handleMouseEnter = function handleMouseEnter(language) {
    this.setState({ cardId: language });
    document.getElementById(language).style.border = '1px solid' + this.props.theme.colorCode;
  };

  Languages.prototype.handleMouseLeave = function handleMouseLeave() {
    document.getElementById(this.state.cardId).style.border = '1px solid #E5E5E5';
  };

  Languages.prototype.render = function render() {
    var _this4 = this;

    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'div',
        { className: this.styles.languages_page_container, style: { width: '100%' }, id: 'languages_listing_page' },
        _react2.default.createElement(
          _Grid2.default,
          null,
          _react2.default.createElement(
            'div',
            { className: this.styles.language_wrapper },
            !this.state.show_search && _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                _Row2.default,
                { className: this.styles.language_header_container, style: { width: '90%' } },
                _react2.default.createElement(
                  _Col2.default,
                  { xs: 12, sm: 6, md: 6, lg: 6 },
                  _react2.default.createElement(
                    'span',
                    { className: this.styles.language_heading },
                    'Select your preferred language'
                  )
                ),
                _react2.default.createElement(
                  _Col2.default,
                  { xs: 12, sm: 6, md: 6, lg: 6, xsHidden: true },
                  _react2.default.createElement(
                    'div',
                    { className: this.styles.search_container },
                    _react2.default.createElement(_components.Search, {
                      label: '',
                      placeholder: 'Search',
                      handleSearch: this.handleSearch.bind(this),
                      style: { 'float': 'right', 'marginRight': '-15px' }
                    })
                  )
                )
              ),
              _react2.default.createElement(
                _Row2.default,
                { className: this.styles.language_list_container, 'data-qa-type': 'list_container' },
                this.getLanguages()
              )
            ),
            this.state.show_search && _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                _Row2.default,
                { className: this.styles.language_header_container, style: { width: '90%' } },
                _react2.default.createElement(
                  _Col2.default,
                  { xs: 12, smHidden: true, mdHidden: true, lgHidden: true, style: { marginTop: '20px' } },
                  _react2.default.createElement(
                    'span',
                    { className: this.styles.language_heading },
                    'Search a language'
                  )
                )
              ),
              _react2.default.createElement(
                _Row2.default,
                { className: this.styles.language_list_container + ' mobile_search_elements' },
                _react2.default.createElement(
                  _Col2.default,
                  { xs: 12, smHidden: true, mdHidden: true, lgHidden: true, className: 'mobile_search_text_field' },
                  _react2.default.createElement(_mozart_ui.MozartTextBox, {
                    ref: 'textbox_mobile_search',
                    id: 'textbox_mobile_search',
                    multiLine: false,
                    validationBool: false,
                    key: 'textbox_mobile_search',
                    limit: 100
                  })
                ),
                _react2.default.createElement(
                  _Col2.default,
                  { xs: 6, smHidden: true, mdHidden: true, lgHidden: true, className: 'mobile_search_button' },
                  _react2.default.createElement(_mozart_ui.MozartButton, {
                    style: { border: '1px solid ' + this.props.theme.colorCode },
                    background: this.props.theme && this.props.theme.colorCode ? this.props.theme.colorCode : true,
                    data: 'Cancel',
                    onClick: function onClick() {
                      if (document.getElementById('textbox_mobile_search')) {
                        _this4.handleSearch('');
                      }
                    }
                  })
                ),
                _react2.default.createElement(
                  _Col2.default,
                  { xs: 6, smHidden: true, mdHidden: true, lgHidden: true, className: 'mobile_search_button' },
                  _react2.default.createElement(_mozart_ui.MozartButton, {
                    style: { border: '1px solid ' + this.props.theme.colorCode },
                    background: this.props.theme && this.props.theme.colorCode ? this.props.theme.colorCode : true,
                    data: 'Search',
                    onClick: function onClick() {
                      if (document.getElementById('textbox_mobile_search')) {
                        _this4.handleSearch(document.getElementById('textbox_mobile_search').value);
                      }
                    }
                  })
                )
              )
            )
          )
        )
      )
    );
  };

  return Languages;
}(_react.Component), _class2.propTypes = {
  onSelectLanguage: _react.PropTypes.func,

  survey: _react.PropTypes.object,
  client: _react.PropTypes.object,
  theme: _react.PropTypes.object,

  selectedLanguage: _react.PropTypes.string,
  currentLanguage: _react.PropTypes.string,

  showSearch: _react.PropTypes.bool
}, _temp)) || _class);
exports.default = Languages;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Languages/Languages.js
// module id = 2338
// module chunks = 0